// extracted by mini-css-extract-plugin
var _1 = "xNz369FCcw0IVQ1FzGYu";
var _2 = "HImi9vMmf42hg5_CQgA1";
var _3 = "FSgkRnmN0HYG4m9DV23E";
var _4 = "oT2l9RfGkGqpkfl5JG3C";
export { _1 as "employee", _2 as "seeAllLink", _3 as "seeAllLinkHolder", _4 as "title" }
